import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
              <a href="/" className="hover:text-primary-400 transition-colors">小草影院</a>
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              小草影院汇集院线大片、最新上映电影及动作片、喜剧电影等分类大全。每日更新片库，高清在线观看各类影片。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base font-heading font-bold text-background-50 mb-4">电影分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.key}>
                  <Link to={`/category/${cat.key}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading font-bold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  全部电影
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  动作片
                </Link>
              </li>
              <li>
                <Link to="/category/comedy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  喜剧电影
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading font-bold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-300 flex items-start gap-2">
                <i className="ri-mail-line text-primary-400 mt-0.5 flex-shrink-0"></i>
                <span>contact@xiaocaocinema.com</span>
              </li>
              <li className="text-sm text-foreground-300 flex items-start gap-2">
                <i className="ri-phone-line text-primary-400 mt-0.5 flex-shrink-0"></i>
                <span>400-888-8888</span>
              </li>
              <li className="text-sm text-foreground-300 flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5 flex-shrink-0"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 小草影院 XiaocaoCinema.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}